import { render, staticRenderFns } from "./serveCompanyDetailFirst.vue?vue&type=template&id=ba7b19b2&scoped=true&"
import script from "./serveCompanyDetailFirst.vue?vue&type=script&lang=js&"
export * from "./serveCompanyDetailFirst.vue?vue&type=script&lang=js&"
import style0 from "./serveCompanyDetailFirst.vue?vue&type=style&index=0&id=ba7b19b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7b19b2",
  null
  
)

export default component.exports